// extracted by mini-css-extract-plugin
export default {"root":"ErrorStateView_root__SgEd+","body":"ErrorStateView_body__udpkL","img":"ErrorStateView_img__m8SWP","fill":"ErrorStateView_fill__TnqQR"};